import {useEffect, useCallback} from "react";
import {Layout} from 'antd'
import {Outlet, useNavigate} from 'react-router-dom'
import Sider from "./Sider";
import Header from "./Header"
import BreadCrumb from "../../components/BreadCrumb";
import cookie from "react-cookies"

const {Content} = Layout

export default function Container(props) {
    const navigate = useNavigate();

    useEffect(() => {
        if (!cookie.load("_tkn_")) {
            navigate('/unauthorized')
        }
    }, [])

    return (
        <Layout className='app-container'>
            <Sider/>
            <Layout className="app-layout">
                <Header className="app-header"/>
                <Content className="app-content">
                    <BreadCrumb/>
                    <Outlet/>
                </Content>
            </Layout>
        </Layout>
    )
}